<div class="input-dialog">
  <h2 mat-dialog-title>
    <mat-icon>
      {{ data.title === 'Státusz módosítása' ? 'edit' : 'info' }}
    </mat-icon>
    {{ data.title }}
  </h2>

  <div mat-dialog-content class="dialog-content">
    <!-- Two-column layout when logs are shown -->
    <div class="dialog-layout" [class.two-column]="data.showLogs && data.logs">
      
      <!-- Left Column: Original Content -->
      <div class="left-column">
        <!-- Company Info Section -->
        @if (data.subtitle || data.details) {
          <div class="company-info">
            @if (data.subtitle) {
              <div class="company-name">{{ data.subtitle }}</div>
            }
            @if (data.details) {
              <div class="company-details">{{ data.details }}</div>
            }
            
            <!-- Officials Section -->
            @if (data.officials && data.officials.length > 0) {
              <div class="officials-section">
                <div class="section-title">Tisztségviselők:</div>
                <div class="chips-container">
                  @for (official of data.officials; track $index) {
                    <app-call-center-chip 
                      [config]="createChipConfig(official, 'official')"
                      [class]="'contact-chip ' + getChipClass(official)"
                      [matMenuTriggerFor]="officialMenu.menu"
                      (click)="onChipClick(createChipConfig(official, 'official'), officialMenuTrigger)"
                      #officialMenuTrigger="matMenuTrigger">
                    </app-call-center-chip>
                  }
                  <!-- Add Officials Button -->
                  <app-circle-icon-button
                    icon="person_add"
                    [matMenuTriggerFor]="smallOfficialInputMenuComponent.menu"
                    (menuOpened)="smallOfficialInputMenuComponent.onMenuOpened()"
                    (menuClosed)="smallOfficialInputMenuComponent.onMenuClosed()"
                    #addOfficialMenuTrigger="matMenuTrigger">
                  </app-circle-icon-button>
                </div>
              </div>
            }

            <!-- Contact Information Section -->
            @if ((data.phoneNumbers && data.phoneNumbers.length > 0) || data.email || (displayEmails && displayEmails.length > 0)) {
              <div class="contacts-section">
                <div class="section-title">
                  Elérhetőségek:
                  @if (hasDuplicatePhones) {
                    <mat-icon 
                      class="duplicate-warning-icon"
                      [matMenuTriggerFor]="duplicatePhoneMenu">
                      warning
                    </mat-icon>
                  }
                </div>
                <div class="chips-container">
                  
                  <!-- Phone Numbers -->
                  @for (phone of data.phoneNumbers; track $index) {
                    <app-call-center-chip 
                      [config]="createChipConfig(phone, 'phone')"
                      [class]="'contact-chip ' + getChipClass(phone) + (duplicatePhonesSet.has(phone) ? ' duplicate-phone-chip' : '')"
                      [matMenuTriggerFor]="phoneMenu.menu"
                      (click)="onChipClick(createChipConfig(phone, 'phone'), phoneMenuTrigger)"
                      #phoneMenuTrigger="matMenuTrigger">
                    </app-call-center-chip>
                  }
                  <!-- Emails (multiple support) -->
                  @for (email of displayEmails; track email) {
                    <app-call-center-chip 
                      [config]="createChipConfig(email, 'email')"
                      [class]="'contact-chip ' + getChipClass(email)"
                      [matMenuTriggerFor]="emailMenu.menu"
                      (click)="onChipClick(createChipConfig(email, 'email'), emailMenuTrigger)"
                      #emailMenuTrigger="matMenuTrigger">
                    </app-call-center-chip>
                  }
                  <!-- Single Email (backward compatibility) -->
                  @if (data.email && data.email !== 'Nincs email' && (!displayEmails || displayEmails.length === 0)) {
                    <app-call-center-chip 
                      [config]="createChipConfig(data.email, 'email')"
                      [class]="'contact-chip ' + getChipClass(data.email)"
                      [matMenuTriggerFor]="emailMenu.menu"
                      (click)="onChipClick(createChipConfig(data.email, 'email'), emailMenuTrigger)"
                      #emailMenuTrigger="matMenuTrigger">
                    </app-call-center-chip>
                  }
                  <!-- Add Phone Button -->
                  <app-circle-icon-button
                    icon="add_call"
                    [matMenuTriggerFor]="smallInputMenuComponent.menu"
                    (menuOpened)="smallInputMenuComponent.onMenuOpened()"
                    (menuClosed)="smallInputMenuComponent.onMenuClosed()"
                    #addPhoneMenuTrigger="matMenuTrigger">
                  </app-circle-icon-button>
                  <!-- Add Email Button -->
                  <app-circle-icon-button
                    icon="alternate_email"
                    [matMenuTriggerFor]="smallEmailInputMenuComponent.menu"
                    (menuOpened)="smallEmailInputMenuComponent.onMenuOpened()"
                    (menuClosed)="smallEmailInputMenuComponent.onMenuClosed()"
                    #addEmailMenuTrigger="matMenuTrigger">
                  </app-circle-icon-button>
                </div>
              </div>
            }
          </div>
        }

        <!-- Status Selector -->
        @if (data.showStatusSelector && data.statusOptions) {
          <div class="status-selector-section">
            <div class="section-title">Státusz: <span class="required-asterisk">*</span></div>
            <div class="chips-container">
              @for (status of data.statusOptions; track status.value) {
                <app-call-center-chip 
                  [config]="createChipConfig(status.label, 'status')"
                  (click)="onChipClick(createChipConfig(status.label, 'status'))">
                </app-call-center-chip>
              }
            </div>
          </div>
        }

        <!-- Call Quality Checkboxes -->
        @if (data.showStatusSelector) {
          <div class="call-quality-section">
            <div class="checkboxes-container">
              <mat-checkbox 
                [(ngModel)]="targetPersonReached"
                [disabled]="!selectedStatus"
                class="quality-checkbox">
                A keresett személyt elérte
              </mat-checkbox>
              <div class="listened-row">
                <mat-checkbox 
                  [(ngModel)]="listenedFully"
                  [disabled]="!selectedStatus"
                  class="quality-checkbox">
                  Végig hallgatta
                </mat-checkbox>

                @if (showReminderSection) {
                  <div class="reminder-trigger-row">
                    @if (reminderDate) {
                      <span class="reminder-set-text">
                        Emlékeztető beállítva: {{ formatReminderDisplay() }}
                      </span>
                    }
                    <app-circle-icon-button
                      icon="add_alert"
                      title="Emlékeztető beállítása"
                      (clicked)="openReminderDialog()">
                    </app-circle-icon-button>
                  </div>
                }
              </div>
            </div>
          </div>
        }

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ data.label }}</mat-label>
          <input 
            matInput 
            [formControl]="inputControl"
            [placeholder]="data.placeholder || ''"
            [type]="data.inputType || 'text'"
            [required]="data.required || false"
            (keydown.enter)="onSave()"
            #inputElement>
        </mat-form-field>
      </div>

      <!-- Right Column: Logs -->
      @if (data.showLogs && data.logs) {
        <div class="right-column">
          <div class="logs-section">
            <div class="logs-header">
              <h3>
                <mat-icon>history</mat-icon>
                Cég logok
              </h3>
            </div>
            <div class="logs-container">
              <app-extended-logs-table 
                [paginatedLogs]="convertedLogs" 
                [loading]="false" 
                [error]="data.logsError || null" 
                [totalLogs]="convertedLogs.length"
                [pageSize]="convertedLogs.length"
                [pageIndex]="0"
                [pageSizeOptions]="[]">
              </app-extended-logs-table>
            </div>
          </div>
        </div>
      }

    </div>
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="onCancel()" class="cancel-button">
      Mégse
    </button>
    @if (data.showStatusSelector) {
      <button 
        mat-raised-button 
        color="accent"
        (click)="onSaveChangesOnly()"
        [disabled]="!hasUnsavedChanges() || !!selectedStatus"
        class="save-changes-button">
        <mat-icon>save_alt</mat-icon>
        Módosítások mentése
      </button>
    }
    <button 
      mat-raised-button 
      color="primary" 
      (click)="onSave()"
      [disabled]="!isValid()"
      class="save-button">
      Mentés
    </button>
  </div>
</div>

<!-- Menus for chip actions -->
<app-small-icon-menu
  #officialMenu
  menuId="officialMenu"
  [canEdit]="true"
  [chipCreatedBy]="data.officialCreatedBy?.[selectedItem]"
  [currentUserId]="currentUser?.id"
  [isAdmin]="isAdmin"
  (actionClicked)="onIconMenuAction($event)">
</app-small-icon-menu>

<app-small-icon-menu
  #phoneMenu
  menuId="phoneMenu"
  [canEdit]="true"
  [chipCreatedBy]="data.phoneCreatedBy?.[selectedItem]"
  [currentUserId]="currentUser?.id"
  [isAdmin]="isAdmin"
  (actionClicked)="onIconMenuAction($event)">
</app-small-icon-menu>

<app-small-icon-menu
  #emailMenu
  menuId="emailMenu"
  [canEdit]="true"
  [chipCreatedBy]="data.emailCreatedBy?.[selectedItem]"
  [currentUserId]="currentUser?.id"
  [isAdmin]="isAdmin"
  (actionClicked)="onIconMenuAction($event)">
</app-small-icon-menu>

<!-- Special input menu for adding new official -->
<app-small-input-menu 
  inputType="official"
  [menuTrigger]="addOfficialMenuTrigger"
  [(inputValue)]="newOfficialName"
  (officialAdded)="saveNewOfficial()"
  (cancelled)="cancelAddOfficial()"
  #smallOfficialInputMenuComponent>
</app-small-input-menu>

<!-- Special input menu for adding new phone -->
<app-small-input-menu 
  [menuTrigger]="addPhoneMenuTrigger"
  [(inputValue)]="editingPhoneInput"
  (phoneAdded)="onPhoneAdded($event)"
  (cancelled)="onPhoneAddCancelled()"
  #smallInputMenuComponent>
</app-small-input-menu>

<!-- Special input menu for adding new email -->
<app-small-input-menu 
  inputType="email"
  [menuTrigger]="addEmailMenuTrigger"
  [(inputValue)]="editingEmailInput"
  (emailAdded)="onEmailAdded($event)"
  (cancelled)="onEmailAddCancelled()"
  #smallEmailInputMenuComponent>
</app-small-input-menu>

<!-- Ismétlődő telefonszámok panel -->
<mat-menu #duplicatePhoneMenu="matMenu" class="duplicate-phone-panel">
  <div class="duplicate-panel-content" (click)="$event.stopPropagation()">
    <div class="duplicate-panel-title">Ismétlődő telefonszámok</div>
    @for (item of duplicatePhonesList; track item.phone) {
      <div class="duplicate-phone-entry">
        <div class="duplicate-phone-number">
          <app-call-center-chip
            [config]="{ text: item.phone, type: 'phone', validStatus: null }">
          </app-call-center-chip>
        </div>
        @for (entity of item.entities; track entity.entity_id) {
          <div class="duplicate-entity-info">
            <div class="entity-header">
              <mat-icon class="entity-type-icon">{{ entity.entity_type === 'company' ? 'business' : 'person' }}</mat-icon>
              @if (entity.entity_type === 'customer') {
                <app-call-center-chip
                  [config]="{ text: entity.entity_name, type: 'official', validStatus: entity.entity_validstatus }">
                </app-call-center-chip>
              } @else {
                <span class="entity-name">{{ entity.entity_name }}</span>
              }
            </div>
            @if (entity.existing_customer) {
              <span class="existing-customer-badge">Meglévő ügyfél</span>
            } @else if (entity.entity_type === 'company') {
              <app-call-center-chip
                [config]="{ text: getCcStatusLabel(entity.cc_status), type: 'status', validStatus: null }">
              </app-call-center-chip>
            }
            @if (entity.officials.length > 0) {
              <div class="officials-list">
                @for (official of entity.officials; track official.name) {
                  <app-call-center-chip
                    [config]="{ text: official.name, type: 'official', validStatus: official.validstatus }">
                  </app-call-center-chip>
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</mat-menu>
